"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const style = "normal";
const brand = "#ecebe4";
const headerBackgroundColor = brand;
const headerTextColor = "#786659";
const mainInfoLandscape = headerTextColor;
const mainInfoPortrait = headerTextColor;
const fontFamily = `
    @font-face {
    font-family: 'Butler Cuffonfonts';
    src: 
        url('/fonts/butler-cuffonfonts/Butler_Ultra_Light.woff') format('woff');
    font-weight: 100;
    font-style: normal;
    }

    @font-face {
    font-family: 'Butler Cuffonfonts';
    src: 
        url('/fonts/butler-cuffonfonts/Butler_Light.woff') format('woff');
    font-weight: 200;
    font-style: normal;
    }

    @font-face {
    font-family: 'Butler Cuffonfonts';
    src: 
        url('/fonts/butler-cuffonfonts/Butler_Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
    }

    @font-face {
    font-family: 'Butler Cuffonfonts';
    src: 
        url('/fonts/butler-cuffonfonts/Butler_Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    }

    @font-face {
    font-family: 'Butler Cuffonfonts';
    src: 
        url('/fonts/butler-cuffonfonts/Butler_Bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
    }

    @font-face {
    font-family: 'Butler Cuffonfonts';
    src: 
        url('/fonts/butler-cuffonfonts/Butler_ExtraBold.woff') format('woff');
    font-weight: 900;
    font-style: normal;
    }
    html {
        font-family: "Butler Cuffonfonts", sans-serif ;
    }
`;
exports.default = {
    brand,
    mainInfoLandscape,
    mainInfoPortrait,
    headerBackgroundColor,
    headerTextColor,
    fontFamily,
    style,
};
